import { INoAuthData } from '~/src/components/NoAuthBanner';

export const NoAuthData: INoAuthData = {
    headerTitle: 'получить доступ к личному кабинету',
};
